import React, { ReactElement } from 'react';
import { Title, Box, Group, BoxProps, createPolymorphicComponent } from '@mantine/core';

import { BreadCrumbs } from 'src/components/navigation/BreadCrumbs'
import { ResponsiveView } from 'src/components/ui/ResponsiveView'
import { BackButton } from 'src/components/ui/shell/BackButton'
import styled from 'styled-components'
import { DefaultTheme } from 'src/theme/theme'

type PageHeaderProps = {
    title: string;
    badge?: ReactElement;
    renderAction?: ReactElement;
    preview?: ReactElement;
}

const _PageHeaderWrapper = styled(Box)`     
    display: flex;
    flex-direction: column;
    justify-content: center;
    [data-mantine-color-scheme='light'] & {
        background-color: var(--mantine-color-gray-1);
    }
    [data-mantine-color-scheme='dark'] & {
        background-color: var(--mantine-color-dark-7);
    }
    @media (max-width: ${DefaultTheme.breakpoints.md}) {
        height: 70px;
    }
    @media (min-width: ${DefaultTheme.breakpoints.md}) {
        height: 90px;
    }
`
const PageHeaderWrapper = createPolymorphicComponent<'div', BoxProps>(_PageHeaderWrapper);

export const PageHeader: React.FC<PageHeaderProps> = ({ title, renderAction, badge, preview }) => {

    return (
        <PageHeaderWrapper>
            <ResponsiveView
                renderDesktop={
                    <Box style={{border:'0px solid red'}}>
                        <Group justify='space-between'>
                            <Box>
                                <BreadCrumbs />
                                <Group>
                                    <Title order={2} style={{ lineHeight: '30px' }}>{title}</Title>
                                    {badge}
                                </Group>
                            </Box>
                            {renderAction}
                        </Group>
                        {preview}
                    </Box>
                }
                renderMobile={
                    <Box>
                        <Group justify='space-between'>
                            <Group gap="xs">
                                <BackButton/>
                                <Group gap="xs">
                                    <Title order={2} style={theme => ({ fontSize: theme.fontSizes.lg })}>{title}</Title>
                                    {badge}
                                </Group>
                            </Group>
                            {renderAction}
                        </Group>
                    </Box>
                }
            />
        </PageHeaderWrapper>
    )
}